<template>
	<div :id="oid" :class="[{ wcSection: true }, { editing: editing }]">
		<div v-if="!editing" :class="{ 'ck-content': isRichText }">
			<div v-if="!loading && isRichText" v-html="activeHtml"></div>
			<render v-if="!loading && isVueComponent" :html="activeHtml"></render>
			<pagePromotion
				v-if="contentType === 'OlympusPagePromotion'"
				:to="section.ToVueRouterName"
				@passBack="BubblePassBack"></pagePromotion>
		</div>
		<wcEditPage
			:parent="parent"
			:contentType="contentType"
			:type="section.ComponentType"
			:section="section"
			:width="section.Width"
			:title="section.Title"
			:text="section.Text"
			v-if="editing"
			@update="UpdateSection"></wcEditPage>
	</div>
</template>
<script>
	import { defineExpose, getCurrentInstance, ref, computed, watch, onMounted, inject } from "vue";
	import store from "@/store";
	import ContentTypes from "@/services/utils/contentTypes";
	import { wcEditPage } from "@/components";
	import { pagePromotion } from "@/components/widgets";
	import render from "@/components/render.vue";
	export default {
		components: {
			wcEditPage,
			render,
			pagePromotion
		},
		props: {
			parent: {
				type: [String],
				default: undefined
			},
			section: {
				type: [Object],
				default: () => {
					return {};
				}
			},
			filters: {
				type: [Object],
				default: () => {
					return {};
				}
			},
			editing: {
				type: [Boolean],
				default: false
			}
		},
		emits: ["UpdateSection", "promoPassBack"],
		setup(props, context) {
			const $json = inject("$json");
			const $oruga = inject("$oruga");
			const $error = inject("$error");
			const $success = inject("$success");
			const $http = inject("$http");

			const loading = ref(true);
			const uuid = ref(props.section.UUID);
			const oid = ref(props.section.OID);
			const activeHtml = ref(props.section.Text);
			const contentType = ref(props.section.Type.Identifier);
			const deleting = ref(false);
			const isAdmin = computed(() => {
				return store.getters.isAdmin;
			});

			const isRichText = computed(() => {
				return contentType.value === ContentTypes.RichText;
			});
			const isVueComponent = computed(() => {
				return contentType.value === ContentTypes.VueComponent;
			});

			const UpdateSection = (result) => {
				context.emit("UpdateSection", { uuid: uuid.value, oid: oid.value, result: result });

				if (isRichText.value) {
					activeHtml.value = result.text;
				} else {
					activeHtml.value = BuildTag();
				}
			};

			const BuildTag = () => {
				const attrs = (props.section.Attributes || []).map((el) =>
					$json.isJSON(el.Value)
						? el.Name + '="' + $json.pack(el.Value) + '"'
						: el.Name + '="' + $json.pack(el.Value) + '"'
				);
				attrs.push('pageFilters="' + $json.pack(JSON.stringify(props.filters || [])) + '"');
				attrs.push('pageId="' + props.parent + '"');
				//console.log("attrs", attrs);

				const prefix =
					"<" + props.section.ComponentType + (attrs.length ? " " + attrs.join(" ") : "") + ">";

				const suffix = "</" + props.section.ComponentType + ">";
				const tag = prefix + suffix;
				return tag;
			};

			const BubblePassBack = (o) => {
				context.emit("promoPassBack", o);
			};

			onMounted(() => {
				if (isVueComponent.value) {
					activeHtml.value = BuildTag();
				}
				loading.value = false;
			});

			return {
				uuid,
				oid,
				contentType,
				loading,
				activeHtml,
				isAdmin,
				isRichText,
				deleting,
				isVueComponent,
				UpdateSection,
				BubblePassBack
			};
		}
	};
</script>
<style lang="scss">
	// .wcSection {
	// 	& > .wcEditBtn {
	// 		display: none;
	// 	}
	// 	&:hover > .wcEditBtn,
	// 	& > wcEditBtn:hover {
	// 		display: block;
	// 	}
	// }
</style>
